module.exports = "/assets/data/c7af5e82bd04b2f6b395bd7d63b97603-CA10.data.json";